<template>
  <div>
    <div v-if="!isProfilePage" class="d-flex align-center justify-center">
      <div class="custom-chip">
        <img src="../../assets/images/gamificationIcon.svg" width="36" />
        <span class="number px-1">{{ amount }}</span>
      </div>
    </div>
    <div v-if="isProfilePage" class="d-flex align-center justify-center">
      <div class="custom-chip-profile-page mx-1">
        <img src="../../assets/images/gamificationIcon.svg" width="24" />
        <span class="number-profile-page px-1">{{ amount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: String,
      required: true,
    },
    isProfilePage: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-chip {
  width: 119px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 6px;
  background: linear-gradient(
    102.02deg,
    #d6c58d 3.12%,
    #ffe68e 52%,
    #dcc05c 95.14%
  );
  border-radius: 36px;
}

.number {
  font-size: 26px;
  font-weight: 700;
  line-height: 33.85px;
  text-align: center;
  color: #39434d;
}

.custom-chip-profile-page {
  width: 90px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 6px;
  background: linear-gradient(
    102.02deg,
    #d6c58d 3.12%,
    #ffe68e 52%,
    #dcc05c 95.14%
  );
  border-radius: 36px;
}
.number-profile-page {
  font-size: 16px;
  font-weight: 700;
  line-height: 33.85px;
  text-align: center;
  color: #39434d;
}
</style>
